// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2K5Sz","productName":"Table_productName__PiPtK"};